import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, LinearProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styles from './PhotoUploadDialog.styles';
import { useDropzone } from 'react-dropzone';
import cn from 'classnames';

// SERVICES
import { saveUploadedImages } from '../../services';
import {
  InspectorOrderReviewContext,
  UPDATE_IMAGES,
} from '../InspectorOrderReview/InspectorOrderReviewContext/InspectorOrderReviewContext';
import { AppContext } from '../../AppContext';

const PhotoUploadDialog = ({ classes, open, setOpen }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [files, setFiles] = useState([]);

  const { dispatch: appDispatch } = useContext(AppContext);
  const {
    state: { order, orderForms },
    dispatch,
  } = useContext(InspectorOrderReviewContext);

  const { getRootProps, getInputProps } = useDropzone({
    accept: '.jpg, .jpeg',
    onDrop: acceptedFiles => {
      setFiles(
        acceptedFiles.map((file, fileIndex) => {
          const fileType = file.name.split('.').slice(-1);

          return Object.assign(file, {
            imageUri: URL.createObjectURL(file),
            fileName: `${new Date().getTime()}${fileIndex}.${fileType}`,
            label: null,
          });
        }),
      );
    },
  });

  const uploadPhotos = async () => {
    // add new images to the misc images array
    // then save to the backend which will generate IDs for the images

    const tempOrderForms = JSON.parse(JSON.stringify(orderForms));

    // console.log(tempOrderForms);

    if (!tempOrderForms.length) {
      return console.log('no order forms to append to...');
    }

    // tempOrderForms[0].miscImages = tempOrderForms[0].miscImages ? tempOrderForms[0].miscImages.concat(...files) : files;

    try {
      setIsSubmitting(true);
      const newImages = await saveUploadedImages(tempOrderForms, order.orderLineId, files);
      dispatch({
        type: UPDATE_IMAGES,
        images: newImages,
      });
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Pictures uploaded successfully',
        },
      });

      // get the image carousel and scroll to the beginning
      const imageCarouselRef = document.getElementById('image-carousel-scrollview');
      if (imageCarouselRef) {
        imageCarouselRef.scrollTo({ left: 0, behavior: 'smooth' });
      }
      // messagesContainerRef.scrollTo({ top: messagesContainerRef.scrollHeight, behavior: 'smooth' });

      // clear state
      setFiles([]);
      setSubmitError(null);
      setSubmitMessage(null);
      setOpen(false);
    } catch (error) {
      console.log(error);
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: 'An error occurred while uploading your images... Please try again',
        },
      });
    }
    setIsSubmitting(false);
  };

  const renderThumb = (file, fileIndex) => (
    <img key={fileIndex} src={file.imageUri} style={{ maxWidth: 125, marginRight: 15, marginBottom: 15 }} />
  );

  // const thumbs = files.map(file => (
  //   <li key={file.path}>
  //     {file.path} - {file.size} bytes
  //   </li>
  // ));

  // console.log(thumbs);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="lg"
      onClose={() => setOpen(false)}
      aria-labelledby="image-modal-title"
      className={classes.photoUploadDialog}
      autoScrollBodyContent={false}
      contentStyle={{ width: '100%', maxWidth: 'none' }}
    >
      <DialogTitle>Photo Upload</DialogTitle>
      <DialogContent>
        <main className={cn('col-center-center', classes.container)}>
          <div {...getRootProps({ className: classes.dropzone })}>
            <input {...getInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>

          <h2>Preview</h2>
          <div className={cn('row-start-center')} style={{ flexWrap: 'wrap' }}>
            {!!files.length && files.map(renderThumb)}
            {!files.length && <div style={{ color: '#777' }}>Please add some photos above</div>}
          </div>
        </main>
      </DialogContent>
      <DialogActions
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Button
          disabled={isSubmitting}
          onClick={() => setOpen(false)}
          variant="contained"
          style={{ backgroundColor: '#315382', color: 'white' }}
        >
          Cancel
        </Button>
        <div style={{ flex: 1, paddingLeft: 10, paddingRight: 10 }}>
          {isSubmitting && <LinearProgress />}
          {submitMessage && <div>{submitMessage}</div>}
          {submitError && <div style={{ color: 'red' }}>{submitError}</div>}
        </div>
        <Button
          disabled={isSubmitting}
          onClick={uploadPhotos}
          variant="contained"
          style={{ backgroundColor: '#315382', color: 'white' }}
        >
          Upload Photos
        </Button>
      </DialogActions>
    </Dialog>
  );
};
PhotoUploadDialog.defaultProps = {};
PhotoUploadDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default withStyles(styles)(PhotoUploadDialog);
